import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dashParamsFromState: '',
  kpiCardVisibility: true,
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setDashParamsToState: (state, action) => {
      state.dashParamsFromState = action.payload; // Store API data
    },
    setKpiCardVisibility: (state, action) => {
      state.kpiCardVisibility = action.payload; // Store API data
    },
  },
});

export const { setDashParamsToState, setKpiCardVisibility } =
  dashboardSlice.actions;
export default dashboardSlice.reducer;
